import { render, staticRenderFns } from "./ChangeDetails.vue?vue&type=template&id=ad43da92&scoped=true"
import script from "./ChangeDetails.vue?vue&type=script&lang=js"
export * from "./ChangeDetails.vue?vue&type=script&lang=js"
import style0 from "./ChangeDetails.vue?vue&type=style&index=0&id=ad43da92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad43da92",
  null
  
)

export default component.exports